import { Component, OnInit, Input } from '@angular/core';
// import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss'],
})
export class FormControlComponent implements OnInit {

  @Input() field: any;
  // @Input() customForm: FormBuilder;
  constructor() { }

  ngOnInit() {
    console.log(this.field)
  }

}
